import { API_URL } from "config";
import Http from "util/https";
import { PrefStockList, PrefStockParams, PrefStockResponseApi, SupplierResponseApi, SupplierSearchApiParams, SupplierStockList, SupplierWarehouse, SupplierWarehouseResponseApi } from "../types/index";
import { convertUTCToDate, nullToZero } from "../utils/common";
import { supplierStockApiResponse } from "./apiConstants";

type Params = {
  vendor_cd?: string;
  depot_kind: 0 | 1;
}

/**
 * 仕入先倉庫を取得するApi
 * @param params Apiのパラメータ
 * @returns 仕入先倉庫list
 */
export default async function getSupplierWarehouseApi(params: Params): Promise<SupplierWarehouse[]> {
  const http = Http.default.alterAuth({useToken: true});
  const url = `${API_URL}/vendor/depot/select`;
  const res = await http.post<SupplierWarehouseResponseApi>(url, params);
  // const res: {data: SupplierWarehouseResponseApi} = {
  //   data: {
  //     total: 15,
  //     depot_kind: !!params.depot_kind,
  //     depot_infos: params.depot_kind
  //       ? [{
  //         depot_kind: 1,
  //         depot_cd: "0002",
  //         depot_name: "地域倉庫2",
  //         pref_infos: [],
  //       },{
  //         depot_kind: 1,
  //         depot_cd: "0003",
  //         depot_name: "地域倉庫3",
  //         pref_infos: [],
  //       }]
  //       : [{
  //         depot_kind: 0,
  //         depot_cd: "0001",
  //         depot_name: "センター倉庫1",
  //         pref_infos: [],
  //       },{
  //         depot_kind: 0,
  //         depot_cd: "0004",
  //         depot_name: "センター倉庫4",
  //         pref_infos: [],
  //       }],
  //   }
  // }
  console.log("getSupplierWarehouseApi:", res.data.depot_infos);

  const warehouseList: SupplierWarehouse[] = res.data.depot_infos.map(di => ({
    code: di.depot_cd,
    name: di.depot_name,
    isCenter: !di.depot_type,
  }));
  console.log('getSupplierWarehouseApi warehouseList:', warehouseList);
  return warehouseList;
}